// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1_xcO"};